import { render, staticRenderFns } from "./CharactersSliderLoading.vue?vue&type=template&id=39ba7165&"
import script from "./CharactersSliderLoading.vue?vue&type=script&lang=js&"
export * from "./CharactersSliderLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports